import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EnvironmentType } from 'src/environments/environmentTypes';

@Component({
  template: '',
})
export class FaviconSwitchComponent implements OnChanges {
  @Input()
  clientId: string;
  favIcon: HTMLLinkElement = document.querySelector('#appIcon');

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.favIcon) return;
    this.favIcon.href = environment.apps[this.clientId].faviconUrl;
  }

  get app(): EnvironmentType['apps'][0] | undefined {
    return environment.apps[this.clientId];
  }
}
